/** Phase 55 · Shared creator metadata (languages, call mode, duration fmt). */

export const LANGUAGES = [
  { code: 'it', flag: '🇮🇹', label: 'Italiano' },
  { code: 'en', flag: '🇬🇧', label: 'Inglese' },
  { code: 'es', flag: '🇪🇸', label: 'Spagnolo' },
  { code: 'fr', flag: '🇫🇷', label: 'Francese' },
  { code: 'de', flag: '🇩🇪', label: 'Tedesco' },
  { code: 'pt', flag: '🇵🇹', label: 'Portoghese' },
];

export const langFlag = (code) => LANGUAGES.find((l) => l.code === code)?.flag || code;
export const langLabel = (code) => LANGUAGES.find((l) => l.code === code)?.label || code;

export const MODE_LABELS = {
  audio: '🎤 Solo Audio',
  audio_video: '🎥 Audio + Video',
};

export const fmtAvgDuration = (seconds) => {
  if (!seconds || seconds <= 0) return null;
  const m = Math.round(seconds / 60);
  if (m < 1) return '< 1 min';
  return `~${m} min`;
};

export const fmtRelativeTime = (iso) => {
  if (!iso) return null;
  const diff = Date.now() - new Date(iso).getTime();
  const mins = Math.floor(diff / 60000);
  if (mins < 1) return 'adesso';
  if (mins < 60) return `${mins} min fa`;
  const hours = Math.floor(mins / 60);
  if (hours < 24) return `${hours}h fa`;
  const days = Math.floor(hours / 24);
  if (days < 30) return `${days}g fa`;
  return new Date(iso).toLocaleDateString('it-IT', { day: 'numeric', month: 'short' });
};

export const fmtMemberSince = (iso) => {
  if (!iso) return null;
  return new Date(iso).toLocaleDateString('it-IT', { month: 'long', year: 'numeric' });
};

// Phase F5.2 — voluntary gender label (NEVER inferred; null → '').
export const genderLabel = (gender, locale = 'it') => {
  const it = { male: 'Uomo', female: 'Donna', other: 'Altro' };
  const en = { male: 'Man', female: 'Woman', other: 'Other' };
  const map = String(locale || 'it').startsWith('it') ? it : en;
  return map[gender] || '';
};
